export const SIGN_UP_BONUS: Record<string, number> = {
  AZN: 500,
  BDT: 27000,
  BRL: 1600,
  EUR: 300,
  INR: 23000,
  KZT: 140000,
  PKR: 62000,
  RUB: 20000,
  TRY: 5000,
  USD: 300,
  UZS: 3000000,
  MMK: 60000,
  KES: 20000,
  LKR: 75000,
  GBP: 150,
  NPR: 27000,
  VND: 5000000,
  KRW: 3000000,
  MYR: 1300,
};
